'use client';

import { useMemo, useState } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { SeoSpecialty } from '@medprev-web-app/api-graphql-client';

import { SpecialtyCard } from '@/app/(main)/(pages)/(institucional)/(index)/especialidades/_components/specialty-card.component';
import { ClientListFilterInput } from '@/components/ui/list-filter-input/client-list-filter-input.component';

export interface FilterableSpecialtyListProps {
  specialties: SeoSpecialty[];
  itemBaseUrl: string;
  titleBaseUrl: string;
  placeholder?: string;
}

function filterSpecialties(specialties: SeoSpecialty[], term: string): SeoSpecialty[] {
  const t = term.trim().toLowerCase();
  if (!t) {
    return specialties;
  }
  return specialties.filter(
    (s) =>
      s != null
      && ((s.name?.toLowerCase().includes(t) ?? false) || (s.slug?.toLowerCase().includes(t) ?? false)),
  );
}

export function FilterableSpecialtyList({
  specialties,
  itemBaseUrl,
  titleBaseUrl,
  placeholder = 'Busque pela especialidade',
}: FilterableSpecialtyListProps) {
  const [filter, setFilter] = useState('');

  const filtered = useMemo(
    () => filterSpecialties(specialties, filter),
    [specialties, filter],
  );

  return (
    <div className="md:space-y-6 border-t md:border-t-0">
      <div className="px-5 md:px-0 mb-6">
        <ClientListFilterInput
          value={filter}
          onChange={setFilter}
          placeholder={placeholder}
          className="max-w-md"
        />
      </div>
      {filtered?.length
        ? filtered.map((specialty) => (
            <SpecialtyCard
              key={specialty.id}
              specialty={specialty}
              itemBaseUrl={itemBaseUrl}
              titleBaseUrl={titleBaseUrl}
            />
          ))
        : (
            <p
              className="px-5 md:px-0 text-gray-600"
              role="status"
              data-testid={DataTestIdEnum.INDEX_LIST_EMPTY_STATE}
            >
              Nenhuma especialidade encontrada para o filtro informado.
            </p>
          )}
    </div>
  );
}
